import { api } from './client'

// ---------- Types (matching backend response shape) ----------

export interface UsageSummary {
  conversations: number
  total_requests: number
  prompt_tokens: number
  completion_tokens: number
  total_tokens: number
  avg_latency_ms: number
  error_count: number
  error_rate_percent: number
  estimated_cost: number
}

export interface OrgUsageRow {
  org_id: string
  org_name: string
  conversations: number
  total_tokens: number
  estimated_cost: number
  error_count: number
}

export interface ModelCostRow {
  model: string
  total_requests: number
  prompt_tokens: number
  completion_tokens: number
  total_tokens: number
  estimated_cost: number
}

export interface TopUserRow {
  user_id: string
  user_name: string
  user_email: string
  request_count: number
  total_tokens: number
}

export interface UsageResponse {
  range: string
  start: string
  end: string
  summary: UsageSummary
  org_breakdown: OrgUsageRow[]
  model_breakdown: ModelCostRow[]
  top_users: TopUserRow[]
}

export type TimeRange = 'today' | '7d' | '30d' | '90d'

export interface UsageParams {
  range: TimeRange
  org_id?: string
}

// ---------- API function ----------

export async function fetchUsageMetrics(params: UsageParams): Promise<UsageResponse> {
  const searchParams = new URLSearchParams()
  searchParams.set('range', params.range)
  if (params.org_id) searchParams.set('org_id', params.org_id)
  return api.get<UsageResponse>(`/api/v1/admin/usage?${searchParams.toString()}`)
}
